import initialState from './initialState.js'

export const resetState = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export const setDevices = (state, devices) => {
  state.devices = devices
}

export const setTotalInstalls = (state, totalInstalls) => {
  state.totalInstalls = totalInstalls
}

export const setUsedInstalls = (state, usedInstalls) => {
  state.usedInstalls = usedInstalls
}

export const removeDevice = (state, deviceId) => {
  const index = state.devices.findIndex(device => device.id === deviceId)

  state.devices.splice(index, 1)

  state.usedInstalls-- // todo: how to deal with this?
}
